var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "graph-outer-container" }, [
    _c("div", { ref: "containerEl", staticClass: "graph-container" }, [
      _c("canvas", { ref: "chartEl" }),
    ]),
    _vm.showingTruncatedWarning
      ? _c("p", { staticClass: "truncated-warning" }, [
          _vm._v(
            " For clarity, some data has not been presented on the graph. A full set of results can be downloaded "
          ),
          _c(
            "span",
            {
              staticClass: "pseudo-link",
              on: {
                click: function ($event) {
                  return _vm.triggerDownload()
                },
              },
            },
            [_vm._v("here")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }